import { css } from '@emotion/react';
import { colors } from '@/constants/colors';

export type Variant = 'primary' | 'secondary';

const commonStyle = css`
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease-out;
`;

const primaryStyle = css`
  ${commonStyle}

  background-color: ${colors.primary};
  color: ${colors.white};

  &:not(:disabled):hover,
  &:not(:disabled):active {
    background-color: ${colors.darkBlue};
    color: ${colors.white};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

const secondaryStyle = css`
  ${commonStyle}

  background-color: ${colors.black800};
  color: ${colors.white};

  &:hover,
  &:active {
    background-color: ${colors.black900};
  }
`;

export const buttonStyle = {
  primary: primaryStyle,
  secondary: secondaryStyle,
} as const;
